import { useTranslation } from "react-i18next";

// styles
require("./PopupGeneralStyles.css");

interface Props {
  id?: number;
  handleCancellation?: any;
  handleEditing?: any;
  handleAdding?: any;
  handleDelete?: any;
  addingText?: any;
  doDelete?: boolean;
}

const PopupOperationsBar = (props: Props) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'General.Buttons' });
  const isDelete = props.doDelete ? true : false;
  return (
    <>
      <div className="popupOperationBar">
        <button
          onClick={() => {
            props.handleCancellation();
          }}
          type="button"
          className="btn-sm btn-secondary"
        >
          {t('Cancel')}
        </button>

        {!props.id && (
          <button
            onClick={() => {
              props.handleAdding();
            }}
            type="button"
            className="btn-sm btn-primary"
          >
            {props.addingText ? props.addingText : t('Create')}
          </button>
        )}

        {props.id && !isDelete && (
          <button
            onClick={() => {
              props.handleEditing();
            }}
            type="button"
            className="btn-sm btn-success"
          >
            {t('Edit')}
          </button>
        )}

        {props.id && isDelete && (
          <button
            onClick={() => {
              props.handleDelete();
            }}
            type="button"
            className="btn-sm btn-success"
          >
            {t('Delete')}
          </button>
        )}


      </div>
    </>
  );
};

export default PopupOperationsBar;
